export default {
    customerInfo: '/sjWebCustomerInfo/addCustomerInfo'
}
